<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{message}}</p>
  <mat-progress-bar mode="determinate" [value]="time"></mat-progress-bar>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="OKHandler()">{{oktext}}</button>
  <button mat-raised-button color="warn" (click)="CancelHandler()">{{canceltext}}</button>
</div>
